import React from "react";
const PipelineFunnel = ({ data }) => {
  const formatPercent = (value) => {
    const fixed = Number(value || 0).toFixed(2);
    return `${fixed.replace(/\.?0+$/, "")}%`;
  };
  const maxCount = Math.max(...data.map((stage) => stage.count || 0), 1);
  const totalCases = data.reduce((acc, stage) => acc + (stage.count || 0), 0);

  return (
    <div className="dark:bg-slate-900 bg-white border dark:border-slate-800 border-slate-200 rounded-xl h-full p-6 animate-slide-up">
      <div className="flex items-center justify-between mb-6">
        <h3 className="dark:text-white text-slate-900 font-bold text-lg">Pipeline Funnel</h3>
        <span className="text-xs text-slate-500 dark:bg-slate-800 bg-slate-100 px-3 py-1 rounded-full border dark:border-slate-700 border-slate-300">Total cases: {totalCases}</span>
      </div>
      <div className="space-y-3">
        {data.map((stage, idx) => (
          <div key={stage.stage}>
            <div className="group flex justify-between items-center dark:bg-slate-800/30 bg-slate-50 p-3 rounded-xl border border-transparent dark:hover:border-sky-500/20 hover:border-sky-200 dark:hover:bg-slate-800/80 hover:bg-slate-100 transition-all duration-300">
              <div className="flex-1">
                <p className="font-semibold dark:text-slate-200 text-slate-800 text-sm">{stage.stage}</p>
                <div className="mt-2 h-2.5 w-full max-w-[180px] dark:bg-slate-900 bg-slate-200 rounded-full overflow-hidden shadow-inner">
                  <div
                    className="h-full bg-gradient-to-r from-sky-600 to-sky-400 rounded-full shadow-[0_0_10px_rgba(56,189,248,0.3)] transition-all duration-1000 ease-out"
                    style={{ width: `${(stage.count / maxCount) * 100}%` }}
                  />
                </div>
              </div>
              <div className="text-right pl-4">
                <p className="font-bold text-xl dark:text-white text-slate-900 group-hover:text-sky-400 transition-colors">{stage.count}</p>
                <p className="text-xs text-slate-500 font-medium">{formatPercent(stage.percentOfActive)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PipelineFunnel;
